// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"wj_a bhu_b"};